import React, {useState} from "react";
import ConfirmModal from "../modal/ConfirmModal";
import {Row} from "react-bootstrap";
import QrCode from "./QrCode";
import IconButton from "../button/IconButton";
import { useTranslation } from "react-i18next";

const QrCodeButton = ({value, filePrefix, disabled = false}) => {

    const { t } = useTranslation();

    const [showQrCodeModal, setShowQrCodeModal] = useState(false);


    return (
        <>
            <IconButton
                disabled={disabled}
                variant="outline-primary"
                onClick={() => setShowQrCodeModal(true)}
                icon="fa-qrcode"
                tooltip={t("common.qr_code")}
            />

            <ConfirmModal
                title={t("common.qr_code")}
                size={"md"}
                show={showQrCodeModal}
                setShow={setShowQrCodeModal}
                alert
                children={

                    <Row className="justify-content-center">
                        <QrCode value={value} filePrefix={filePrefix}/>
                    </Row>

                }
            />

        </>
    );
};

export default QrCodeButton;